// Copyright (c) 2026 by Audere

import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";

import { getErrorText } from "../utils/errors";
import { globalStyles } from "../utils/styles";

const ErrorPage = () => {
  const error = useRouteError() as any;
  const navigate = useNavigate();
  return (
    <Box>
      <Typography variant="h4">Something went wrong</Typography>
      <Typography variant="body1" sx={globalStyles.gapTop}>
        An unexpected error has occurred.
      </Typography>
      <Typography>{getErrorText(error)}</Typography>
      <Box sx={globalStyles.gapTop}>
        <Button variant="outlined" onClick={() => navigate("/")}>
          Go home
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorPage;
